<div>
    <div class="content">
        <list-view #listeFacturesTypesCharges [liste]="factureTypeChargeListView" *ngIf="factureTypeChargeListView"></list-view>
    </div>
    <floating-button *ngIf="listeActions?.value" [listeActions]="listeActions"></floating-button>
</div>

